module.exports = "<div [ngSwitch]=\"view\" class=\"views\">\r\n\r\n    <fuse-chat-contact-sidenav class=\"view\"\r\n                               *ngSwitchCase=\"'contact'\"\r\n                               [@slideInRight]>\r\n    </fuse-chat-contact-sidenav>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/chat/sidenavs/right/right.component.html
// module id = ./src/app/main/content/pages/chat/sidenavs/right/right.component.html
// module chunks = main